var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2305_20294",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.254 0.0605469H14.3316C6.61386 0.0605469 0.357422 6.31698 0.357422 14.0347V55.9571C0.357422 63.6748 6.61386 69.9312 14.3316 69.9312H56.254C63.9717 69.9312 70.2281 63.6748 70.2281 55.9571V14.0347C70.2281 6.31698 63.9717 0.0605469 56.254 0.0605469Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2305_20294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1083 0.103889C22.9282 0.136641 22.7426 0.169393 22.5843 0.278565C21.9457 0.709799 21.8037 1.60502 22.2349 2.24368L25.2481 6.74161C20.5919 9.20892 17.1202 13.3084 15.9902 18.2266H54.5938C53.4639 13.3084 49.9921 9.20892 45.3359 6.74161L48.3491 2.24368C48.7803 1.60502 48.6384 0.709799 47.9998 0.278565C47.3557 -0.152668 46.4659 0.0329264 46.0346 0.671588L42.7158 5.56254C40.4123 4.7219 37.9122 4.25246 35.292 4.25246C32.6719 4.25246 30.1718 4.7219 27.8683 5.56254L24.5494 0.671588C24.2273 0.191227 23.6433 0.000174444 23.1083 0.103889ZM27.6063 11.2395C28.7634 11.2395 29.7024 12.1784 29.7024 13.3357C29.7024 14.4983 28.7634 15.4318 27.6063 15.4318C26.4436 15.4318 25.5101 14.4983 25.5101 13.3357C25.5101 12.1784 26.4436 11.2395 27.6063 11.2395ZM42.9778 11.2395C44.1404 11.2395 45.0739 12.1784 45.0739 13.3357C45.0739 14.4983 44.1404 15.4318 42.9778 15.4318C41.8205 15.4318 40.8817 14.4983 40.8817 13.3357C40.8817 12.1784 41.8205 11.2395 42.9778 11.2395ZM11.536 21.0214C9.22153 21.0214 7.34375 22.8992 7.34375 25.2137V44.7775C7.34375 47.0919 9.22153 48.9697 11.536 48.9697C12.0273 48.9697 12.4967 48.866 12.9334 48.7077V21.2834C12.4967 21.1252 12.0273 21.0214 11.536 21.0214ZM15.7282 21.0214V51.7645C15.7282 54.0735 17.6115 55.9568 19.9205 55.9568H50.6636C52.9726 55.9568 54.8558 54.0735 54.8558 51.7645V21.0214H15.7282ZM59.0481 21.0214C58.5568 21.0214 58.0873 21.1252 57.6507 21.2834V48.7077C58.0873 48.8605 58.5568 48.9697 59.0481 48.9697C61.3625 48.9697 63.2403 47.0919 63.2403 44.7775V25.2137C63.2403 22.8992 61.3625 21.0214 59.0481 21.0214ZM21.3179 58.7516V64.3413C21.3179 67.4254 23.8235 69.9309 26.9075 69.9309C29.9916 69.9309 32.4972 67.4254 32.4972 64.3413V58.7516H21.3179ZM38.0869 58.7516V64.3413C38.0869 67.4254 40.5924 69.9309 43.6765 69.9309C46.7606 69.9309 49.2662 67.4254 49.2662 64.3413V58.7516H38.0869Z",
    fill: "url(#paint0_linear_2305_20294)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2305_20294",
    x1: 18.8108,
    y1: -0.0701966,
    x2: 67.773,
    y2: 3.23079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.965517ec5fe68629e96f8f5a014f9ddc.svg";
export { ForwardRef as ReactComponent };